export const STUCKED_PROGRESS_BAR_TIMEOUT = 0;
